// extracted by mini-css-extract-plugin
export default {"AffichageCabinetUtilisateur":"AffichageCabinet_AffichageCabinetUtilisateur__zvzqX"};